import type { DeepPartial } from '@luna/utils-ts';

import type { Payments } from './Payments';

export const SK: DeepPartial<Payments> = {};
